import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import MenuTable from "../../helpers/MenuTable";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import InputComboRokMiesiac from "../../helpers/InputComboRokMiesiac";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";



export default function Free(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);

 
    const [filterParam, setFilterParam] = useState({  

        men_dziennik_id: props.id,
        rok:  new Date().getFullYear(),
        miesiac: new Date().getMonth()+1,              
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);


    
    const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

             if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
           

            props.mainView.writeFilter(filedName, val);
        }

    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

            
      const filterClear = () => {
 
 
       
            setFilterParam({
 
               men_dziennik_id: props.id,
               rok:  new Date().getFullYear(),                
               miesiac: new Date().getMonth()+1,        
                        

                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },


                limit: 50,
                page: 1,
                show: true, 
            });
            setTab(null);
        }


 const filterApprove = () => {   
     setTab(null)     
 }




 
    const getTab = () => {
            
        
            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,free', {
                method: 'POST', 
                body: JSON.stringify(filterParam), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);             

                            if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }


   const setStan = (e) => {
          
    
        if(props.status != "aktywny" ) return;

        
            //atr-dzien={ob.dzien} atr-dziecko-id={ob.p_dziecko_id} atr-status={ob.status} onClick={setStan}
           var dzien       = e.target.getAttribute('atr-dzien');
           var p_dziecko_id = e.target.getAttribute('atr-dziecko-id');
           var status       = e.target.getAttribute('atr-status');

           if(status == 'o') {
            status = 'n';
           }else status = 'o';

           var req = {
            dzien: dzien,
            men_dziennik_id: props.id,
            p_dziecko_id: p_dziecko_id,
            stan: status,
           };


            props.mainView.setProgress(-2);
        

            fetch( Config.url + '/rest_v1_men,free_set', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            getTab();
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                    

            return false;
    }



   if(tab == null)
   {
      setTab([]);
      getTab(); 
      return <div>...</div>
   }


   if(  tab.days == undefined) 
   {
         return <div>...</div>
   }




        return <div>


                    <div className="table_filter">

                        <div className="filter_controll">   
                            <label>Rok: </label>                             
                            <InputComboRok   userData={props.userData}  mainView={props.mainView}   value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={"Rok: "}     />
                        </div>

                        <div className="filter_controll">   
                            <label>Miesiąc: </label>                             
                            <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}   value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={"Miesiąc: "}     />
                        </div>


                        <div className="filter_btn">                           
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                    </div>


                      <div className="table_widget">    
                            <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={props.title  } />  

                            &nbsp;&nbsp;  &nbsp;&nbsp;  'o' - obecny  &nbsp; 'n' - nieboecny
                            <div>Ta zakładka jest również aktualizowana automatycznie na podstawie aktywnych umów dzieci i zgłoszonych nieobecności. </div>
                       </div>


                      <div ref={tabRef} className="gohide">
                          <h3>{props.title}, rok: {filterParam.rok}, miesiąc: {filterParam.miesiac}</h3>   

                                 <table className="table" >

                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className="">Imię i nazwisko</td>                                                     
                                                   
                                                    {
                                                        tab.days.map( (itemDay, inx) => {
                                                            return <td>
                                                                {itemDay.day.substring(8,10)}
                                                            </td>
                                                        } )
                                                    }

                                                    <td> OB </td>                                                                                                                                                                                                                                     
                                                    <td className="td_right"> NB </td>                                                                                                                                                                                                                                     
                                                                                         
                                                </tr>
                                        </thead>

                                        <tbody>

                                            {
                                                tab.ob.map( (rowOb, ixKey) => {

                                                    var rowStyle = " row ";
                                                    if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                    return <tr className={rowStyle} key={ixKey}>
                                                            <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                          
                                                            {
                                                                rowOb.map( (ob, inxOb) => {

                                                                      var css1 = "";    
                                                                      if(ob.t != "dziecko") css1 = " gocenter ";

                                                                      if(ob.t == "dzien" && ob.w == 0)    css1 = css1 + " e_squere_nd ";
                                                                      if(ob.t == "dzien" && ob.w == 6)    css1 = css1 + " e_squere_sb ";
                                                                         
                                                                       
                                                                      if( ob.t == "dzien")
                                                                      {
                                                                            return <td className={css1} atr-dzien={ob.dzien} atr-dziecko-id={ob.p_dziecko_id} atr-status={ob.status} onClick={setStan} > 
                                                                                         {ob.status} 
                                                                                    </td>
                                                                      }else 
                                                                      {
                                                                                return <td className={css1}> 

                                                                                            {
                                                                                                ob.t == "dziecko" &&
                                                                                                <Fragment>{ob.dziecko.nazwisko} {ob.dziecko.imie}</Fragment>
                                                                                            }
                                                                                           
                                                                                            {
                                                                                                ob.t == "sum_ob" &&
                                                                                                <Fragment>{ob.num}  </Fragment>
                                                                                            }

                                                                                            {
                                                                                                ob.t == "sum_nb" &&
                                                                                                <Fragment>{ob.num}  </Fragment>
                                                                                            }

                                                                                    </td>


                                                                      }
                                                                   

                                                                     

                                                                }  )

                                                            }

                                                    </tr>

                                                } )
                                            }

                                            <tr>
                                                <td> </td>
                                                <td className="goright">Razem obecnych</td>
                                                  {
                                                    tab.obSumDay.map( (item, ix) => {
                                                        return <td className="gocenter">
                                                            {item.ilosc}
                                                        </td>
                                                    } )
                                                  }  
                                                <td className="gocenter">{tab.obAll}</td>  
                                                <td></td>
                                            </tr>

                                             <tr>
                                                <td> </td>
                                                <td className="goright">Razem nieobecnych</td>
                                                  {
                                                    tab.nbSumDay.map( (item, ix) => {
                                                        return <td className="gocenter">
                                                            {item.ilosc}
                                                        </td>
                                                    } )
                                                  }  
                                                <td></td>
                                                <td className="gocenter">{tab.nbAll}</td>  
                                            </tr>

                                        </tbody>

                            </table>
                             
                     </div> 

                          <div className="scorll_x">
          

                            <table className="table" >

                                        <thead>
                                                <tr className="header">                                                    
                                                    <td className="td_left">LP</td>                                                                                                                                           
                                                    <td className="">Imię i nazwisko</td>                                                     
                                                   
                                                    {
                                                        tab.days.map( (itemDay, inx) => {
                                                            return <td>
                                                                {itemDay.day.substring(8,10)}
                                                            </td>
                                                        } )
                                                    }

                                                    <td> OB </td>                                                                                                                                                                                                                                     
                                                    <td className="td_right"> NB </td>                                                                                                                                                                                                                                     
                                                                                         
                                                </tr>
                                        </thead>

                                        <tbody>

                                            {
                                                tab.ob.map( (rowOb, ixKey) => {

                                                    var rowStyle = " row ";
                                                    if(ixKey % 2 == 0 )rowStyle = " row2 ";


                                                    return <tr className={rowStyle} key={ixKey}>
                                                            <td className="gocenter">{ixKey+1}</td>                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                          
                                                            {
                                                                rowOb.map( (ob, inxOb) => {

                                                                      var css1 = "";    
                                                                      if(ob.t != "dziecko") css1 = " gocenter ";

                                                                      if(ob.t == "dzien" && ob.w == 0)    css1 = css1 + " e_squere_nd ";
                                                                      if(ob.t == "dzien" && ob.w == 6)    css1 = css1 + " e_squere_sb ";
                                                                         
                                                                       
                                                                      if( ob.t == "dzien")
                                                                      {
                                                                            return <td className={css1} atr-dzien={ob.dzien} atr-dziecko-id={ob.p_dziecko_id} atr-status={ob.status} onClick={setStan} > 
                                                                                         {ob.status} 
                                                                                    </td>
                                                                      }else 
                                                                      {
                                                                                return <td className={css1}> 

                                                                                            {
                                                                                                ob.t == "dziecko" &&
                                                                                                <Fragment>{ob.dziecko.nazwisko} {ob.dziecko.imie}</Fragment>
                                                                                            }
                                                                                           
                                                                                            {
                                                                                                ob.t == "sum_ob" &&
                                                                                                <Fragment>{ob.num}  </Fragment>
                                                                                            }

                                                                                            {
                                                                                                ob.t == "sum_nb" &&
                                                                                                <Fragment>{ob.num}  </Fragment>
                                                                                            }

                                                                                    </td>


                                                                      }
                                                                   

                                                                     

                                                                }  )

                                                            }

                                                    </tr>

                                                } )
                                            }

                                            <tr>
                                                <td> </td>
                                                <td className="goright">Razem obecnych</td>
                                                  {
                                                    tab.obSumDay.map( (item, ix) => {
                                                        return <td className="gocenter">
                                                            {item.ilosc}
                                                        </td>
                                                    } )
                                                  }  
                                                <td className="gocenter">{tab.obAll}</td>  
                                                <td></td>
                                            </tr>

                                             <tr>
                                                <td> </td>
                                                <td className="goright">Razem nieobecnych</td>
                                                  {
                                                    tab.nbSumDay.map( (item, ix) => {
                                                        return <td className="gocenter">
                                                            {item.ilosc}
                                                        </td>
                                                    } )
                                                  }  
                                                <td></td>
                                                <td className="gocenter">{tab.nbAll}</td>  
                                            </tr>

                                        </tbody>

                            </table>
             </div>
             

        </div>
}